import $ from 'jquery';
import { HTTP_STATUS_OK } from '../../smartpak/httpstatus';
import loadingMessage from "../../views/shared/loadingmessage";
import modal from '../../smartpak/modal';

const userStatus = {
    SUCCESS: 0,
    USER_NAME_EXISTS: 1
};

var braintreeWrapper = {
    _clientCreate: function(onCreate, config) {
        window.braintree.client.create(
            {
                authorization:
                    config.env === 'production'
                        ? 'production_3833xk8m_zw2jcdvqjy6w8yx4'
                        : 'sandbox_fwz8cscb_svz9tvmr2cgyktx5'
            },
            function(clientErr, clientInstance) {
                // Stop if there was a problem creating the client.
                // This could happen if there is a network error or if the authorization
                // is invalid.
                if (clientErr) {
                    // eslint-disable-next-line no-console
                    console.error('Error creating client:', clientErr);
                    this._showErrorMessage(config);
                    return;
                }

                if (onCreate) {
                    onCreate(clientInstance);
                }
            }.bind(this)
        );
    },
    _paypalCheckoutCreate: function(clientInstance, onCreate, config) {
        // Create a PayPal Checkout component.
        window.braintree.paypalCheckout.create(
            {
                client: clientInstance
            },
            function(paypalCheckoutErr, paypalCheckoutInstance) {
                // Stop if there was a problem creating PayPal Checkout.
                // This could happen if there was a network error or if it's incorrectly
                // configured.
                if (paypalCheckoutErr) {
                    // eslint-disable-next-line no-console
                    console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                    this._showErrorMessage(config);
                    return;
                }

                if (onCreate) {
                    onCreate(paypalCheckoutInstance);
                }
            }.bind(this)
        );
    },
    _getCopy: function(pathname) {
        return /cart/gi.test(pathname)
            ? "We're sorry, there was an error preventing us from connecting to your PayPal account. Please try logging into PayPal again, or use our SmartPak checkout, in order to complete your order."
            : /checkout/gi.test(pathname)
            ? "We're sorry, there was an error preventing us from connecting to your PayPal account. Please try logging into PayPal again, or enter a credit card instead, in order to complete your order."
            : "We're sorry, there was an error preventing us from connecting to your PayPal account. Please try logging into PayPal again, or enter a credit card instead.";
    },
    _getButtonCopy: function(pathname) {
        return /cart/gi.test(pathname) ? 'Complete Checkout' : 'Enter Credit Card';
    },
    _showErrorMessage: function(config) {
        if (this._errorModal) {
            return;
        }

        var modalButtonID = 'paypal-error-modal',
            buttons =
                '<div class="paypal-error-buttons"><div id="' +
                modalButtonID +
                '"></div><button class="paypal-error-button sp-modal-close">' +
                this._getButtonCopy(location.pathname) +
                '</button></div>',
            html = '<p>' + this._getCopy(location.pathname) + '</p>' + buttons,
            $content = document.createElement('div');

        $content.classList.add('jsHide');
        $content.classList.add('paypal-error-modal-wrap');
        $content.innerHTML = html;

        document.body.appendChild($content);

        this._errorModal = this._modal($content, {
            removeContents: true,
            open: function() {
                this.createPayPalButton({
                    buttonID: modalButtonID,
                    env: config.env,
                    postURL: config.postURL,
                    returnURL: config.returnURL,
                    label: 'paypal'
                });
            }.bind(this),
            close: function() {
                if (this._errorModal) {
                    this._errorModal = null;
                }
            }.bind(this)
        });
    },
    _modal: function (content, options) {
        return modal(content, options);
    },
    _signIn: function (onLogin) {
        import('../../views/customeraccount/launchmodal.js').then(({ default: launchModal }) =>
            launchModal({
                success: onLogin
            })
        );
    },
    _userExistsPrompt: function (email, onLogin) {
        const $element = document.createElement('div');

        $element.innerHTML = `<p>We found an account associated with your email, <strong>${email}</strong></p>`;

        this._modal($element, {
            title: 'Please sign in to check out',
            buttons: {
                'Sign In': (modal) => {
                    modal.close();
                    this._signIn(onLogin);
                }
            }
        });
    },
    _handlePostResponse: function ({ postResponse, payloadResponse, config }) {
        if (!postResponse || postResponse.status !== HTTP_STATUS_OK || !postResponse.content) {
            this._showErrorMessage(config);
            return;
        }

        const handleSuccess = () => {
            if (typeof config.onsuccess === 'function') {
                config.onsuccess(payloadResponse);
                return;
            }

            if (config.returnURL) {
                this._redirectToUrl(config.returnURL);
            }
        };

        if (postResponse.content?.status === userStatus.USER_NAME_EXISTS) {
            this._userExistsPrompt(payloadResponse.email, handleSuccess);
            return;
        }

        handleSuccess();
    },
    _redirectToUrl(url) {
        if (!url) {
            return;
        }

        location.href = url;
    },
    _paypalButtonRender: function(paypalCheckoutInstance, config) {
        // Set up PayPal with the checkout.js library
        window.paypal.Button.render(
            {
                env: config.env, // 'sandbox' or 'production'

                payment: function() {
                    return paypalCheckoutInstance.createPayment({
                        flow: 'vault',
                        billingAgreementDescription: '',
                        enableShippingAddress: true,
                        shippingAddressEditable: false
                    });
                },

                onAuthorize: function(data) {
                    loadingMessage.show(true);

                    return paypalCheckoutInstance.tokenizePayment(
                        data,
                        function(err, payload) {
                            if (err) {
                                return;
                            }

                            var payloadResponse = flattenPayload(payload);

                            if (this._errorModal) {
                                this._errorModal.close();
                            }

                            $.ajax({
                                url: config.postURL,
                                type: 'POST',
                                data: JSON.stringify({
                                    payload: payloadResponse
                                }),
                                contentType: 'application/json'
                            })
                                .done(postResponse => {
                                    loadingMessage.hide();
                                    this._handlePostResponse({ postResponse, payloadResponse, config });
                                })
                                .fail(
                                    function() {
                                        this._showErrorMessage(config);
                                    }.bind(this)
                                );
                        }.bind(this)
                    );
                }.bind(this),

                onCancel: function() {
                    if (this._errorModal) {
                        this._errorModal.close();
                    }
                }.bind(this),

                onError: function(err) {
                    // eslint-disable-next-line no-console
                    console.error('checkout.js error', err);
                    if (this._errorModal) {
                        this._errorModal.close();
                    }
                }.bind(this),
                style: {
                    color: 'white',
                    shape: 'rect',
                    tagline: false,
                    label: config.label,
                    layout: 'horizontal',
                    size: 'responsive',
                    height: 48
                }
            },
            config.buttonID
        ).then(function() {
            // The PayPal button will be rendered in an html element with the id
            // `paypal-button`. This function will be called when the PayPal button
            // is set up and ready to be used.
        });
    },
    createPayPalButton: function(config) {
        this._clientCreate(
            function(clientInstance) {
                this._paypalCheckoutCreate(
                    clientInstance,
                    function(paypalCheckoutInstance) {
                        this._paypalButtonRender(paypalCheckoutInstance, config);
                    }.bind(this),
                    config
                );
            }.bind(this),
            config
        );
    }
};

function flattenPayload(source, destination) {
    var d = destination || {};

    Object.keys(source).forEach(function(key) {
        if (typeof source[key] === 'string') {
            d[key] = source[key];
        } else {
            flattenPayload(source[key], d);
        }
    });

    return d;
}

window.smartPak = window.smartPak || {};
window.smartPak.braintree = braintreeWrapper;